export default "__VITE_ASSET__D0$5B_MA__"